const CryptoJS = require('crypto-js') // 引用AES源码js

// const key = CryptoJS.enc.Hex.parse('0321ebeba1f75de2d3cd3471af7418a4') // 十六位十六进制数作为密钥
// const iv = CryptoJS.enc.Hex.parse('0321ebeba1f75de2d3cd3471af7418a5') // 十六位十六进制数作为密钥偏移量

const key 		= CryptoJS.enc.Utf8.parse('chenlingjun1987_')//('1n2W!dEr@8f4P3"gSql:<`~XC5b)*?T(vBHY>|6"u7jz&JNs$Bi^KMoe#B6YF0kJ9a,;\\%/+.\'][-=')
const iv 		= CryptoJS.enc.Utf8.parse('1234567890123412')

// 解密方法
function Decrypt (word) {
    // let cipherParams = CryptoJS.lib.CipherParams.create({ciphertext:CryptoJS.enc.Hex.parse(word)})
    let decrypt = CryptoJS.AES.decrypt(word, key, {
        iv:iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    // let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    // console.log('decryptedStr', decryptedStr.toString())
    // return decryptedStr.toString()
    return decrypt.toString(CryptoJS.enc.Utf8);
}

// 加密方法
function Encrypt (word) {
    let encrypted = CryptoJS.AES.encrypt(word, key, {
        iv:iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    // console.log('encrypted', encrypted.toString())
    // return encrypted.toString()
    return encrypted.toString()//CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}
export default {
    Decrypt,
    Encrypt
}


// WEBPACK FOOTER //
// ./src/helper/encrypt.js